<template>
  <div class="fixed inset-0 z-50 flex-col hidden p-8 text-center text-black bg-white print:flex print:text-left">
    <app-logo class="mx-auto mb-8" />

    <div class="w-full h-full">
      <slot />
    </div>
  </div>
</template>

<script>
import isElectron from 'is-electron'
import { useToast } from 'vue-toastification'

import AppLogo from '@/components/AppLogo.vue'

const { ipcRenderer } = isElectron() ? require('electron') : {}

export default {
  name: 'PrintContent',
  components: {
    AppLogo,
  },
  emits: ['done'],
  data () {
    return {
      isPrinting: false,
      isElectron: isElectron(),
    }
  },
  mounted () {
    const toast = useToast()

    if (this.isElectron) {
      ipcRenderer.on('print-success', () => {
        this.isPrinting = false

        toast.success('Printing is completed!', {
          position: 'bottom-left',
          timeout: 5000,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          icon: true,
        })

        this.done()
      })

      ipcRenderer.on('print-failed', (event, arg) => {
        this.isPrinting = false

        toast.error('Nothing is printed.', {
          position: 'bottom-left',
          timeout: 5000,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          icon: true,
        })

        this.done()
      })
    }
  },
  methods: {
    done () {
      this.$emit('done')
    },
    print () {
      if (this.isElectron) {
        ipcRenderer.send('print')
        this.isPrinting = true
      }
    },
  },
}
</script>
